import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SnippetService } from '../snippet.service';
import { CmsService } from '../cms.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-snippet-edit',
    templateUrl: './snippet-edit.component.html',
    styleUrls: ['./snippet-edit.component.scss']
})
export class SnippetEditComponent implements OnInit {
    @Input() snippet;
    @Output() modalAction: EventEmitter<any> = new EventEmitter<any>();


    env = environment;
    pages = [];

    types = [
        { Id: 'wysiwyg', name: 'Text area' },
        { Id: 'image', name: 'Image' },
        { Id: 'plugin', name: 'Plugin' },
        { Id: 'video', name: 'Video' },
        { Id: 'c2a', name: 'Call to action' },
    ];
    paddingsH = [
        { Id: '', name: 'None' },
        { Id: 'px-1', name: 'Padding x 1' },
        { Id: 'px-2', name: 'Padding x 2' },
        { Id: 'px-3', name: 'Padding x 3' },
        { Id: 'px-4', name: 'Padding x 4' },
        { Id: 'px-5', name: 'Padding x 5' },
    ];
    paddingsV = [
        { Id: '', name: 'None' },
        { Id: 'py-1', name: 'Padding x 1' },
        { Id: 'py-2', name: 'Padding x 2' },
        { Id: 'py-3', name: 'Padding x 3' },
        { Id: 'py-4', name: 'Padding x 4' },
        { Id: 'py-5', name: 'Padding x 5' },
    ];
    backgroundColours = [
        { Id: '', name: 'None' },
        { Id: 'bg-grey', name: 'grey' },
        { Id: 'bg-white', name: 'White' },
        { Id: 'bg-teal', name: 'Teal' },
    ];



    tinyInit = {
        height: 500,
        menubar: false,
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
        ],
        toolbar:
            'undo redo | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help'
    };

    constructor(
        private snippetService: SnippetService,
        private cmsService: CmsService,
    ) { }

    ngOnInit() {
        this.cmsService.getAll().subscribe(data => {
            this.pages = data.data;
        });
    }

    save() {
        const dataToEmit = {
            completed: true,
            snippet: this.snippet,
        };
        this.snippetService.saveSnippet(this.snippet).subscribe(data => {
            this.modalAction.emit(dataToEmit);
        });
    }
    cancel() {
        const dataToEmit = {
            completed: false,
        };
        this.modalAction.emit(dataToEmit);
    }

}
